import React from "react"

interface TagProps {
  name: string,
  icon?: string,
}

class TagInner extends React.Component<TagProps> {
  renderIcon() {
    const { icon } = this.props
    let iconClasses = ""

    if (icon !== "") {
      iconClasses = `mr-2 ${icon}`
    }

    return (
      <i className={iconClasses} />
    )
  }

  render() {
    const { name } = this.props

    return (
      <span className="mt-3 mr-4 text-sm leading-4 whitespace-no-wrap flex w-auto">
        {this.renderIcon()}
        <span>{name}</span>
      </span>
    )
  }
}

export function Tag(props: TagProps) {
  return <TagInner {...props} />
}
